<template>
  <!-- 帮帮-发布需求 -->
  <div class="firm-body">
    <div class="help-body">
      <!-- 标题 帮帮-店铺管理 发布需求-->
      <p class="title-Individual-center">
        <span class="firm-clickable" @click="handelBack">店铺管理</span>
        <i class="el-icon-arrow-right firm-clickable"></i><span @click="handelBack">店铺商品</span>
        <i class="el-icon-arrow-right"></i>
        <span class="span-Individual-center">编辑/发布需求</span>
      </p>
      <!-- 内容 -->
      <div class="help-Content">
        <!-- 案例编辑 标题 -->
        <div class="top-title">
          <p class="title">编辑/发布需求</p>
          <div class="Back" @click="handelBack">
            <div class="Back-style">
              <div></div>
              <p>返回</p>
            </div>
          </div>
        </div>

        <!-- 需求编辑输入区 -->
        <div class="form-box">
          <div class="aroundModule">
            <!-- 需求标题 -->
            <div class="container">
              <p class="container-title">
                <span style="color: red">*</span>需求标题：
              </p>
              <el-input
                v-model="ruleForm.title"
                placeholder="请输入"
              ></el-input>
            </div>
          </div>
          <div class="aroundModule">
            <!-- 需求标签 -->
            <div class="container">
              <p class="container-title">
                <span style="color: red">*</span>需求标签：
              </p>
              <el-input v-model="ruleForm.tag" placeholder="请输入"></el-input>
            </div>
          </div>
        </div>
        <!-- 需求描述 -->
        <div class="Description">
          <p class="container-title">
            <span style="color: red">*</span>需求描述：
          </p>
          <el-input
            type="textarea"
            placeholder="请简明描述您的需求，为了保护好个人隐私，请不要填写手机号、QQ、微信等联系方式及广告和违法内容，一经发现会冻结您的店铺及账号，一切后果由个人承担！"
            v-model="ruleForm.textarea"
            maxlength="120"
            show-word-limit
            resize="none"
            :autosize="true"
          >
          </el-input>
        </div>
        <!-- 金额方式 -->
        <div class="Description">
          <p class="container-title">
            <span style="color: red">*</span>金额方式：
          </p>
          <div class="amountWay">
            <div class="WayTitle">
              <p
                v-for="(item, index) in WayArr"
                :key="index"
                :class="item.id == WaySelect ? 'WaySelect' : ''"
                @click="WaySelect = item.id"
              >
                {{ item.name }}
              </p>
            </div>
            <div class="WayCon">
              <div class="content" v-if="WaySelect == 1">
                <el-input
                  v-model="ruleForm.title"
                  placeholder="请输入"
                ></el-input>
                <span>—</span>
                <el-input
                  v-model="ruleForm.title"
                  placeholder="请输入"
                ></el-input>
              </div>
              <div
                class="content"
                v-else
                v-for="(item, index) in offerArr"
                :key="index"
              >
                <div
                  class="icon-select"
                  :class="item.id == offerSelect ? 'offerSelect' : ''"
                  @click="offerSelect = item.id"
                ></div>
                {{ item.name }}
                <div class="Options-input" v-if="item.input">
                  <el-input
                    v-model="ruleForm.offerInput"
                    placeholder="请输入"
                  ></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 需求编辑输入区 -->
        <div class="form-box">
          <div class="aroundModule">
            <!-- 职位技能 -->
            <div class="container">
              <p class="container-title">职位技能：</p>
              <el-select v-model="ruleForm.skill" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <!-- 可参与地区 -->
            <div class="container">
              <p class="container-title">可参与地区：</p>
              <el-select v-model="ruleForm.skill" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <!-- 需求截止时间 -->
            <div class="container">
              <p class="container-title">
                <span style="color: red">*</span>需求截止时间：
              </p>
              <el-date-picker
                v-model="ruleForm.xCutoff"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="aroundModule">
            <!-- 经验要求 -->
            <div class="container">
              <p class="container-title">经验要求：</p>
              <el-select v-model="ruleForm.EXP" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <!-- 可参与人数 -->
            <div class="container">
              <p class="container-title">可参与人数：</p>
              <el-select v-model="ruleForm.EXP" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <!-- 招标截止时间 -->
            <div class="container">
              <p class="container-title">
                <span style="color: red">*</span>招标截止时间：
              </p>
              <el-date-picker
                v-model="ruleForm.zCutoff"
                type="date"
                placeholder="选择日期"
              >
              </el-date-picker>
            </div>
          </div>
        </div>
        <!-- 是否开发票 -->
        <div class="Description">
          <p class="container-title">
            <span style="color: red">*</span>是否开发票：
          </p>
          <div class="invoice-select">
            <div
              class="content"
              v-for="(item, index) in invoiceArr"
              :key="index"
              style="width: 100%"
            >
              <div
                class="icon-select"
                :class="item.id == invoiceSelect ? 'offerSelect' : ''"
                @click="invoiceSelect = item.id"
              ></div>
              {{ item.name }}
              <div
                class="Options-input"
                v-if="item.select && invoiceSelect == 2"
              >
                <p
                  v-for="(item1, index1) in invoiceTypeArr"
                  :key="index1"
                  :class="item1.id == invoiceType ? 'select-p' : ''"
                  @click="invoiceType = item1.id"
                >
                  {{ item1.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部按钮区 -->
      <div class="button-box">
        <div class="button-cen">
          是否上架招标
          <el-switch
            v-model="value1"
            active-color=" #409eff "
            inactive-color="#8A8A8A"
          >
          </el-switch>
        </div>
        <div class="submit-box">
          <p>删除</p>
          <p class="submit">确定</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruleForm: {
        title: "", // 需求标题
        tag: "", // 需求标签
        textarea: "", //需求描述
        offerInput: "", // 设置招标金额
        skill: "", //职位技能
        EXP: "", //经验要求
        xCutoff: "", //需求截止时间
        zCutoff: "", //招标截止时间
      }, //v-model
      options: [], // 下拉选择框选项
      value1: false, //
      WayArr: [
        {
          name: "预算金额",
          id: 1,
        },
        {
          name: "招标金额",
          id: 2,
        },
      ], // 金额方式
      WaySelect: 1, //金额方式选择
      offerArr: [
        {
          name: "根据招标报价",
          id: 1,
        },
        {
          name: "设置招标金额",
          id: 2,
          input: "1",
        },
      ], // 招标报价
      offerSelect: 1, //招标报价选择
      invoiceArr: [
        {
          name: "否",
          id: 1,
        },
        {
          name: "是",
          id: 2,
          select: "1",
        },
      ], // 招标报价
      invoiceSelect: 1, //招标报价选择
      invoiceTypeArr: [
        {
          name: "电子发票",
          id: 1,
        },
        {
          name: "纸质发票",
          id: 2,
        },
      ], // 发票性质：电子/纸质
      invoiceType: 1,
    };
  },
  watch: {},
  components: {},
  created() {},
  destroyed() {},
  methods: {
    handelBack() {
      this.$router.push({
        path: "/HelpShop/ShopProduct",
        query: { key: 2 },
      });
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-input__inner {
  height: 35px !important;
  border: 1px solid #409eff ;
}
// 输入框的样式
/deep/.el-textarea {
  height: 70px !important;
  border-radius: 5px;
}
/deep/.el-textarea__inner {
  height: 70px !important;
  border: 1px solid #409eff ;
}
/deep/.el-textarea .el-input__count {
  bottom: 0px !important;
}
.el-icon-arrow-right {
  margin-left: 4px;
  margin-right: 4px;
}
.firm-body {
  width: 100%;
  flex: 1;
  height: 100%;
  display: flex;
  .help-body {
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
  }
}
//主体
.help-Content {
  min-width: 1140px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 5px;
  margin-top: 13px;
  margin-bottom: 20px;
  padding: 30px;
  // 标题
  .top-title {
    width: 100%;
    height: 40px;
    display: flex;
    position: relative;
    margin-bottom: 40px;
    .title {
      width: 300px;
      height: 40px;
      line-height: 40px;
      background: #409eff ;
      border-radius: 10px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      margin: auto;
    }
    .Back {
      width: 110px;
      height: 30px;
      background: rgba(97, 144, 232, 0.3);
      border-radius: 5px;
      display: flex;
      position: absolute;
      right: 0;
      top: 5px;
      cursor: pointer;
      .Back-style {
        width: 50px;
        height: 17px;
        line-height: 17px;
        margin: auto;
        display: flex;
        div {
          width: 14px;
          height: 17px;
          background-image: url("../../../../../assets/imgs/back-da@3x.svg");
          background-size: 100% 100%;
        }
        p {
          font-size: 14px;
          color: #409eff ;
          margin-left: 5px;
          cursor: pointer;
        }
      }
    }
  }
  // 基本信息 编辑输入区
  .form-box {
    width: 90%;
    min-height: 35px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    text-align: right;
    line-height: 17px;
    font-weight: 400;
    .aroundModule {
      width: 45%;
    }
  }
  // 基本信息 编辑输入区
  .container {
    width: 100%;
    min-height: 35px;
    line-height: 35px;
    display: flex;
    margin-bottom: 30px;
    .container-title {
      min-width: 110px;
      text-align: right;
    }
    .edition-p {
      width: 90px;
      height: 33px;
      border: 1px solid #409eff ;
      border-radius: 5px;
      text-align: center;
      margin-right: 15px;
      font-size: 12px;
      color: #409eff ;
    }
    .edition-select {
      background: rgba(97, 144, 232, 0.27);
      border: 1px solid #409eff ;
    }
  }
  // 需求描述
  .Description {
    width: 90%;
    min-height: 35px;
    display: flex;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #333333;
    font-weight: 400;
    margin: 0 auto;
    margin-bottom: 30px;
    .invoice-select {
      width: 100%;
      height: 70px;
    }
    .container-title {
      min-width: 110px;
      line-height: 35px;
      text-align: right;
    }
    .amountWay {
      width: 355px;
      height: 170px;
      .WayTitle {
        width: 100%;
        height: 35px;
        display: flex;
        p {
          width: 50%;
          height: 35px;
          background: #eeeeee;
          border: 1px solid #999999;
          border-radius: 10px 10px 0px 0px;
          font-size: 12px;
          color: #333333;
          text-align: center;
          line-height: 35px;
        }
        .WaySelect {
          background: rgba(97, 144, 232, 0.2);
          border: 1px solid #409eff ;
          border-radius: 10px 10px 0px 0px;
          color: #409eff ;
        }
      }
      .WayCon {
        width: 100%;
        height: 135px;
        box-sizing: border-box;
        border: 1px solid #409eff ;
        border-radius: 0px 0px 5px 5px;
        display: flex;
        flex-direction: column;
      }
    }
    .content {
      width: 90%;
      height: 35px;
      line-height: 35px;
      margin: auto;
      display: flex;
      span {
        margin-left: 10px;
        margin-right: 10px;
      }
      .icon-select {
        width: 18px;
        height: 18px;
        border: 1px solid gray;
        border-radius: 50%;
        margin: auto 0;
        margin-right: 15px;
      }
      .offerSelect {
        border: 1px solid #409eff ;
        background-image: url("../../../../../assets/imgs/gouxuan@3x.svg");
        background-size: 100% 100%;
      }
      .Options-input {
        width: 160px;
        margin-left: 15px;
        display: flex;
        .select-p {
          background: rgba(97, 144, 232, 0.27);
        }
        p {
          width: 90px;
          height: 35px;
          line-height: 35px;
          text-align: center;
          background: #ffffff;
          border: 1px solid #409eff ;
          border-radius: 5px;
          font-size: 12px;
          color: #409eff ;
          margin-right: 10px;
        }
      }
    }
  }
}
// 底部按钮区
.button-box {
  width: 100%;
  height: 74px;
  background: #ffffff;
  box-shadow: 0px -5px 10px 0px rgba(153, 153, 153, 0.5);
  border-radius: 0px 0px 20px 20px;
  margin-top: -25px;
  margin-bottom: 20px;
  display: flex;
  .button-cen {
    font-size: 16px;
    height: 25px;
    line-height: 25px;
    color: #333333;
    margin: auto 0;
    margin-left: 30px;
  }
  .submit-box {
    flex: 1;
    height: 40px;
    display: flex;
    margin: auto;
    justify-content: flex-end;
    p {
      width: 120px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #ffffff;
      border: 1px solid #999999;
      border-radius: 5px;
      font-size: 16px;
      color: #333333;
      margin-right: 30px;
    }
    .submit {
      background: #409eff ;
      color: #ffffff;
    }
  }
}
</style>
